// import 'babel-polyfill';
import setBucketURL from './util';

const main = document.querySelector('#infoarte main');

const margin = {
  top: 40, right: 20, bottom: 40, left: 20,
};
let width = parseInt(d3.select('.campo').style('width'), 10);
let height = parseInt(d3.select('.campo').style('height'), 10);
let innerWidth = width - margin.left - margin.right;
let innerHeight = height - margin.top - margin.bottom;

// ESCALAS
const espessura = d3.scaleLinear();
const espessuraMax = d3.scaleQuantize();
const pos_x = d3.scalePoint();
const pos_y = d3.scalePoint();
const tamanhoNode = d3.scaleQuantize();

const dados = [
  {},
  {},
];

const instanceSimulation = [];

// Cores das selecoes da esquerda e da direita (respectivamente) no ".range()"
const corLegenda = d3.scaleOrdinal()
  .domain([0, 1])
  .range(['#FFD550', '#D38888']);


// Cria lista de nós a partir da base bruta
function extraiPos(base) {
  const j = [];
  base.forEach((d) => {
    j.push({
      id: d.source,
      pos_x: +d.pos_x,
      pos_y: +d.pos_y,
    });
  });

  return j;
}

// Para cada fluxo de passe, cria uma entrada de source -> target -> passes
function trataCSV(dadosCsv) {
  const csvHorizontal = [];
  dadosCsv.forEach((d) => {
    Object.keys(d).forEach((item) => {
      if (d[item] && item !== 'pos_x' && item !== 'pos_y' && d.source !== d[item]) {
        csvHorizontal.push({
          source: d.source,
          target: item,
          quant: +d[item],
        });
      }
    });
  });
  return csvHorizontal;
}


// O dado do fluxo de passes é direcional e inclui tanto o sentido A -> B quanto
// o sentido B -> A. O gráfico, porém, precisa simplificar tudo num só sentido.
// Essa função serve pra padronizar o sentido e a ordem dos dados
function organizaLinks(j) {
  const k = [];
  j.forEach((d) => {
    const sourceTemp = d.source;
    const targetTemp = d.target;
    if (d.source > d.target) {
      k.push({
        source: targetTemp,
        target: sourceTemp,
        quant: d.quant,
      });
    } else {
      k.push({
        source: d.source,
        target: d.target,
        quant: d.quant,
      });
    }
  });

  k.sort((a, b) => {
    if (a.source > b.source) return 1;
    if (a.source < b.source) return -1;
    if (a.target > b.target) return 1;
    if (a.target < b.target) return -1;
    // a must be equal to b
    return 0;
  });
  return k;
}

// Para que não existam linhas de passe duplicadas, vamos consolidar o valor do número
// de passes entre source/targets iguais (independente da ordem) numa única ocorrência
function somaLinks(data) {
  const linksTemp = [];
  let prevsource = '';
  let prevtarget = '';
  let sum = 0;
  data.forEach((d) => {
    sum = d.quant;
    if (d.source === prevsource && d.target === prevtarget) {
      linksTemp[linksTemp.length - 1].quant += sum;
    } else {
      linksTemp.push({
        source: d.source,
        target: d.target,
        quant: d.quant,
      });
    }
    prevsource = d.source;
    prevtarget = d.target;
  });
  return linksTemp;
}

function start(param, index) {
  // Parâmetros das forças da simulação da física
  const simulation = d3.forceSimulation()
    .force('link', d3.forceLink().id(d => d.id))
    .force('center', d3.forceCenter(width / 2, height / 2));
  const campinho = d3.select(`svg#campo${index}`).append('g');
  campinho.attr('fill', '#fff');
  instanceSimulation.push(simulation);

  // setinha do SENTIDO DE ATAQUE
  const ataque = d3.select(`svg#campo${index}`).append('g')
    .attr('class', 'labelSentido')
    .attr('transform', `translate(${width - 20},${margin.top + 80})rotate(-90)`);

  ataque.append('text')
    .html('Sentido do ataque &#x27a4;');

  espessuraMax.domain([300, 700]).range([12, 20, 26]);
  // espessura.domain(d3.extent(param.links, d => d.quant)).range([1, espessuraMax(width)]);
  espessura.domain([1, 50]).range([1, espessuraMax(width)]);
  // Domain manualmente modificado pro jogo contra a Costa Rica
  tamanhoNode.domain([300, 700]).range([6, 10, 13]);

  pos_x.domain(d3.range(9)).range([innerWidth + margin.left, margin.left]).padding([0.5]);
  pos_y.domain(d3.range(11)).range([innerHeight, margin.top]);

  // LINKS
  const linkG = campinho.append('g').attr('class', 'links_g');
  const link = linkG.selectAll('.links').data(param.links)
    .enter().append('line')
    .attr('class', 'links')
    .attr('stroke', corLegenda(index))
    .attr('stroke-opacity', 1);

  link.attr('stroke-width', d => espessura(d.quant));

  // LABELS DA QUANTIDADE DOS PASSES
  const labelPasses = linkG.selectAll('.label-quant').data(param.links)
    .enter()
    .append('text')
    .attr('class', 'label-quant')
    .attr('text-anchor', 'middle')
    .attr('fill', 'black')
    .attr('display', 'none')
    .attr('pointer-events', 'none')
    .text(d => d.quant);

  // NODES
  const nodes = campinho.selectAll('.nodes').data(param.nodes)
    .enter().append('g')
    .attr('class', 'nodes')
    .attr('opacity', 1)
    .style('cursor', 'pointer');

  nodes.append('circle').attr('class', 'node_circle')
    .attr('r', tamanhoNode(main.clientWidth))
    .attr('fill', 'black');

  nodes.on('mouseover', highlightON)
    .on('mouseout', highlightOFF);

  // LABELS
  nodes.append('text').attr('class', 'labels')
    .attr('text-anchor', 'middle')
    .attr('fill', 'black')
    .attr('y', '1.75em')
    .text(d => d.id);


  // HIGHLIGHTS
  const timing = 100;

  function highlightON(item) {
    link.transition().duration(timing)
      .attr('stroke-opacity', o => (o.source.id === item.id || o.target.id === item.id ? 1 : 0.15));

    const linkedByIndex = {};
    link.each((d) => {
      linkedByIndex[`${d.source.index}, ${d.target.index}`] = 1;
      linkedByIndex[`${d.source.index}, ${d.source.index}`] = 1;
      linkedByIndex[`${d.target.index}, ${d.source.index}`] = 1;
      linkedByIndex[`${d.target.index}, ${d.target.index}`] = 1;
    });

    function neighboring(a, b) {
      return linkedByIndex[`${a.index}, ${b.index}`] || linkedByIndex[`${b.index}, ${a.index}`];
    }
    nodes.transition().duration(timing)
      .attr('opacity', o => (neighboring(item, o) ? 1 : 0.05));

    labelPasses.transition().duration(timing)
      .attr('display', o => (o.source.id === item.id || o.target.id === item.id ? 'block' : 'none'));
  }

  function highlightOFF() {
    link.transition().duration(timing).attr('stroke-opacity', 1);
    nodes.transition().duration(timing).attr('opacity', 1);
    labelPasses.transition().duration(timing).attr('display', 'none');
  }

  // INICIA SIMULAÇÃO
  simulation
    .nodes(param.nodes)
    .on('tick', ticked);

  simulation.force('link')
    .links(param.links)
    .distance(100);

  function ticked() {
    link
      .attr('x1', d => d.source.x)
      .attr('y1', d => d.source.y)
      .attr('x2', d => d.target.x)
      .attr('y2', d => d.target.y);

    nodes
      .attr('transform', (d) => {
        d.fx = pos_x(d.pos_x);
        d.fy = pos_y(d.pos_y);
        return `translate(${d.fx},${d.fy})`;
      });

    labelPasses
      .attr('x', d => (d.source.x + d.target.x) / 2)
      .attr('y', d => (d.source.y + d.target.y) / 2);
  }

  // LEGENDA
  const legenda = d3.select(`#legenda${index}`).append('svg');

  legenda.append('g')
    .attr('class', 'legendSize')
    .attr('transform', 'translate(20, 20)');

  const legendSizeLine = d3.legendSize()
    .scale(espessura)
    .shape('line')
    .orient('horizontal')
    .labelWrap(100)
    .shapeWidth(40)
    .labelOffset(20)
    .labelFormat(d3.format('.0f'))
    .title('Volume de passes');

  legenda.select('.legendSize').call(legendSizeLine);
  d3.selectAll(`#legenda${index} .swatch`)
    .attr('stroke', corLegenda(index));
}

function updateLink() {
  espessura.domain([1, 50]).range([1, espessuraMax(main.clientWidth)]);
  const allLinks = document.querySelectorAll('.links_g');
  allLinks.forEach((item) => {
    d3.select(item).selectAll('.links')
      .attr('stroke-width', d => espessura(d.quant));
  });
}

function resize() {
  const campo = document.querySelector('.bg-campinho');
  if (campo.clientWidth < 280) return;
  width = campo.clientWidth > 600 ? 600 : campo.clientWidth;

  height = width * 1.5;

  innerWidth = width - margin.left - margin.right;
  innerHeight = height - margin.top - margin.bottom;

  pos_x.range([innerWidth + margin.left, margin.left]);
  pos_y.range([innerHeight, margin.top]);

  d3.selectAll('.campo')
    .attr('width', width)
    .attr('height', height);

  d3.selectAll('.labelSentido')
    .attr('transform', `translate(${width - 20},${margin.top + 80})rotate(-90)`);

  d3.selectAll('.nodes')
    .attr('transform', (d) => {
      d.fx = pos_x(d.pos_x);
      d.fy = pos_y(d.pos_y);
      return `translate(${d.fx},${d.fy})`;
    });

  d3.selectAll('.node_circle')
    .attr('r', tamanhoNode(main.clientWidth));

  instanceSimulation.forEach((instance) => {
    instance.force('link', d3.forceLink().id(d => d.id));
    instance.force('center', d3.forceCenter(width / 2, height / 2));
    instance.alpha(1).restart();
  });
  updateLink();
}

function transformaDados(arr, index) {
  dados[index].nodes = extraiPos(arr);
  const response = organizaLinks(trataCSV(arr));
  dados[index].links = somaLinks(response);
  start(dados[index], index);
  d3.select(window).on('resize', resize);
}

function recebeDados(d) {
  let index = 0;
  for (const item of d) {
    transformaDados(item, index);
    index += 1;
  }
}

Promise.all([
  d3.csv(`${setBucketURL(0)}/csv/jogo3-brasil.csv`),
  d3.csv(`${setBucketURL(0)}/csv/jogo3-adv.csv`),
]).then(recebeDados);

resize();
